import React, { useState, useRef } from "react";
import "./Contactus.css";
import { useNavigate } from "react-router-dom";
import { createContactus } from "../api/requestDemo";

const initialStates = {
  portal_name: "Teksett",
  requested_demo_for_product_name: "Teksett portal",
  first_name: "",
  last_name: "",
  orgnization_email: "",
  orgnization_name: "Teksett",
  message: "",
  country: "",
  onSite: false,
};

const ApplyNow = () => {
  const nav = useNavigate();
  const [formData, setFormData] = useState(initialStates);
  const [resumeFile, setResumeFile] = useState(null);
  const [isDragging, setIsDragging] = useState(false);
  const fileInputRef = useRef(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setResumeFile(file);
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    const file = e.dataTransfer.files[0];
    if (file) {
      const validTypes = ['.pdf', '.doc', '.docx', '.txt'];
      const fileExt = '.' + file.name.split('.').pop().toLowerCase();
      if (validTypes.includes(fileExt)) {
        setResumeFile(file);
      } else {
        alert('Please upload a PDF, DOC, DOCX, or TXT file');
      }
    }
  };

  const handleDropZoneClick = () => {
    fileInputRef.current.click();
  };

  const removeFile = () => {
    setResumeFile(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { onSite, ...rest } = formData;
    const bodyData = { ...rest };
    try {
      const res = await createContactus(bodyData);
      setFormData(initialStates);
      setResumeFile(null);
      alert(res.data.message);
    } catch (error) {
      alert(error);
    }
  };

  return (
    <>
      <div className="C-sec">
        <div className="c-sec-1">
          <img className="ct-img" src="./PBimages/applynow.png" alt="" />
        </div>

        <div className="c-sec-2">
          <span className="c-sec-2-sp1">
            {" "}
            <span className="XS-sec1-two-sp1" onClick={() => nav("/insights")}>
              <span className="" style={{ padding: "2px" }}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="6"
                  height="9"
                  viewBox="0 0 7 12"
                  fill="none"
                >
                  <path
                    d="M5.66966 11.2002L6.48437 10.3961L1.62896 5.60426L6.48437 0.804276L5.66965 0.000196528L-0.000464929 5.60426L5.66966 11.2002Z"
                    fill="black"
                  />
                </svg>{" "}
              </span>
              Back to Careers
            </span>
          </span>
          <h1 className="c-sec-2-h1">
            Apply <span>Now</span>{" "}
          </h1>

          <section className="c-sec9">
            <form onSubmit={handleSubmit} className="c-sec3-form">
              <h6 className="c-sec3-form-h6">
                Apply to this job by Filling this Form
              </h6>
              <input
                type="text"
                className="c-sec3-form-p1"
                name="first_name"
                placeholder="First Name"
                onChange={handleChange}
                required
              />
              <input
                type="text"
                className="c-sec3-form-p1"
                placeholder="Last Name"
                name="last_name"
                onChange={handleChange}
                required
              />
              <input
                type="email"
                className="c-sec3-form-p1"
                placeholder="Email ID"
                name="orgnization_email"
                onChange={handleChange}
                required
              />
              <input
                type="text"
                className="c-sec3-form-p1"
                placeholder="Company Name"
                name="orgnization_name"
                onChange={handleChange}
                required
              />
              <input
                type="text"
                className="c-sec3-form-p1"
                placeholder="Your Location"
                name="country"
                onChange={handleChange}
                required
              />
              <select
                className="c-sec3-form-p1"
                onChange={handleChange}
                name="onSite"
                required
              >
                <option>Choose the Onsite option</option>
                <option value={true}>Yes</option>
                <option value={false}>No</option>
              </select>

              {/* Drag and Drop Resume Upload */}
              <div
                className={`resume-dropzone ${isDragging ? 'dragging' : ''} ${resumeFile ? 'has-file' : ''}`}
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
                onClick={handleDropZoneClick}
              >
                <input
                  type="file"
                  ref={fileInputRef}
                  onChange={handleFileChange}
                  accept=".pdf,.doc,.docx,.txt"
                  style={{ display: 'none' }}
                />
                {resumeFile ? (
                  <div className="file-preview">
                    <svg className="file-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                      <polyline points="14 2 14 8 20 8"></polyline>
                      <line x1="16" y1="13" x2="8" y2="13"></line>
                      <line x1="16" y1="17" x2="8" y2="17"></line>
                      <polyline points="10 9 9 9 8 9"></polyline>
                    </svg>
                    <div className="file-info">
                      <span className="file-name">{resumeFile.name}</span>
                      <span className="file-size">{(resumeFile.size / 1024).toFixed(1)} KB</span>
                    </div>
                    <button
                      type="button"
                      className="remove-file"
                      onClick={(e) => {
                        e.stopPropagation();
                        removeFile();
                      }}
                    >
                      ✕
                    </button>
                  </div>
                ) : (
                  <div className="dropzone-content">
                    <svg className="upload-icon" xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                      <polyline points="17 8 12 3 7 8"></polyline>
                      <line x1="12" y1="3" x2="12" y2="15"></line>
                    </svg>
                    <p className="dropzone-text">
                      <span className="dropzone-highlight">Click to upload</span> or drag and drop
                    </p>
                    <p className="dropzone-hint">PDF, DOC, DOCX or TXT (max 5MB)</p>
                  </div>
                )}
              </div>

              <textarea
                className="c-sec3-form-p1 cover-letter"
                placeholder="Cover letter or additional message (optional)"
                name="message"
                onChange={handleChange}
                rows={3}
              />

              <button className="c-sec3-button">Submit Application</button>
            </form>
          </section>
        </div>
      </div>
    </>
  );
};

export default ApplyNow;
